<template>
  <div class="modal fade" id="Commit" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-12 my-auto">
            <span><a class="close"><i class="far fa-times-circle fa-2x" data-dismiss="modal" id="closeCommitBill"
                  aria-label="Close"></i></a></span>
          </div>
        </div>
        <div class="container-fluid" v-if="details">
          <form @submit.prevent="submit">
            <div class="modal-body">
              <div class="container-fluid">
                <!-- Delivery method start -->
                <div class="row mt-2">
                  <div class="col-sm-12">
                    <p class="font-weight-bold d-inline">Delivered automatically by:</p>
                    <div class="row">
                      <div class="col-12">
                        <!-- We use normal check boxes everywhere else but to use checkboxes with preticked data not sure if we need to use BSV inputs? https://bootstrap-vue.js.org/docs/components/form-checkbox/ -->

                        <!-- <div class="row d-flex">
                              <div class="col-6 no-pad align-self-center">
                                <div class="form-check-inline d-flex">
                                  <div class="p-2 align-self-center">
                                    <span class="d-inline">
                                      <label class="checkbox">
                                        <input type="checkbox" v-model="details.BillDeliveryMethods" value="Email" />
                                        <span class="default"></span>
                                      </label>
                                    </span>
                                  </div>
                                  <div class="align-self-center pl-2">
                                    <span class="d-inline">Email</span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-6 no-pad align-self-center">
                                <div class="form-check-inline d-flex">
                                  <div class="p-2 align-self-center">
                                    <span class="d-inline">
                                      <label class="checkbox">
                                        <input type="checkbox" v-model="details.BillDeliveryMethods" value="Post" />
                                        <span class="default"></span>
                                      </label>
                                    </span>
                                  </div>
                                  <div class="align-self-center pl-2">
                                    <span class="d-inline">Post</span>
                                  </div>
                                </div>
                              </div>
                            </div> -->

                        <b-form-radio-group v-model="billDeliveryMethod" class="my-2">
                          <b-form-radio class="ml-2 mb-2" name="Email" value="Email">Email</b-form-radio>
                          <b-form-radio class="ml-2 mb-2" name="Post" value="Post">Post</b-form-radio>
                          <b-form-radio class="ml-2 mb-2" name="Manual" value="Manual">Manual</b-form-radio>
                        </b-form-radio-group>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Delivery method end -->
                <!-- Are you sure start -->
                <div class="row mt-3">
                  <div class="col-sm-12">
                    <p class="font-weight-bold">Are you sure you want to commit this bill?</p>
                  </div>
                  <div class="col-sm-12 text-center no-pad">
                    <button type="submit" class="btn btn-hc w-40 mr-2 mb-3"
                      :disabled="submitStatus === 'PENDING'">Yes</button>
                    <button type="submit" class="btn btn-hc w-40 ml-2 mb-3" data-dismiss="modal"
                      aria-label="Close">No</button>
                  </div>
                </div>
                <!-- Are you sure end -->
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  data() {
    return {
      submitStatus: null,
    };
  },
  computed: {
    details() {
      return this.$store.state.finances.billDetails;
    },
    defaultBillDeliveryMethods() {
      return this.$store.state.customers.customer.BillDeliveryMethods;
    },
    billDeliveryMethod: {
      get() {
        return this.details.BillDeliveryMethods[0];
      },
      set(val) {
        this.details.BillDeliveryMethods = [val];
      }
    }
  },
  methods: {
    isEqual(value, other) {
      // Get the value type
      var type = Object.prototype.toString.call(value);

      // If the two objects are not the same type, return false
      if (type !== Object.prototype.toString.call(other)) return false;

      // If items are not an object or array, return false
      if (["[object Array]", "[object Object]"].indexOf(type) < 0) return false;

      // Compare the length of the length of the two items
      var valueLen =
        type === "[object Array]" ? value.length : Object.keys(value).length;
      var otherLen =
        type === "[object Array]" ? other.length : Object.keys(other).length;
      if (valueLen !== otherLen) return false;

      // Compare two items
      var compare = function (item1, item2) {
        // Get the object type
        var itemType = Object.prototype.toString.call(item1);

        // If an object or array, compare recursively
        if (["[object Array]", "[object Object]"].indexOf(itemType) >= 0) {
          if (!this.isEqual(item1, item2)) return false;
        }

        // Otherwise, do a simple comparison
        else {
          // If the two items are not the same type, return false
          if (itemType !== Object.prototype.toString.call(item2)) return false;

          // Else if it's a function, convert to a string and compare
          // Otherwise, just compare
          if (itemType === "[object Function]") {
            if (item1.toString() !== item2.toString()) return false;
          } else {
            if (item1 !== item2) return false;
          }
        }
      };

      // Compare properties
      if (type === "[object Array]") {
        for (var i = 0; i < valueLen; i++) {
          if (compare(value[i], other[i]) === false) return false;
        }
      } else {
        for (var key in value) {
          if (value.hasOwnProperty(key)) {
            if (compare(value[key], other[key]) === false) return false;
          }
        }
      }

      // If nothing failed, return true
      return true;
    },
    submit() {
      // do your submit logic here
      this.submitStatus = "PENDING";
      setTimeout(() => {
        this.$http
          .put(
            "https://" +
            Vue.config.honeycomb.billbot.domain +
            "/api/v1/Commit/" +
            this.details.Id,
            {
              BillIds: this.details.Id,
              OverrideDeliveryMethodPreference: !this.isEqual(
                this.details.BillDeliveryMethods,
                this.defaultBillDeliveryMethods
              ),
              BillDeliveryMethods: !this.isEqual(
                this.details.BillDeliveryMethods,
                this.defaultBillDeliveryMethods
              )
                ? this.details.BillDeliveryMethods
                : undefined,
            },
            {
              withCredentials: true,
            }
          )
          .then(() => {
            // eslint-disable-next-line
            this.submitStatus = "OK";
            this.$snotify.success(`Success! Bill committed.`);
            document.getElementById("closeCommitBill").click();
            this.$store.dispatch("getBills");
            this.$store.dispatch("getLedger");
            this.$store.dispatch("getCharges");
            this.$store.dispatch("getUsage");
            this.$store.dispatch("refreshReadings");

            setTimeout(() => {
              this.$store.dispatch("refreshCustomer");
            }, 3000);
          })
          .catch((error) => {
            // Error
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              this.submitStatus = "Error";
              if (error.response.data.MoreInformation.length > 0) {
                error.response.data.MoreInformation.forEach((e) => {
                  this.$snotify.error(`${e.Error}`, {
                    timeout: 0,
                    closeOnClick: true,
                  });
                });
              } else {
                this.$snotify.error(`${error.response.data.UserDescription}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              this.submitStatus = "Error";
              this.$snotify.error(`No response received.`, {
                timeout: 0,
                closeOnClick: true,
              });
            } else {
              // Something happened in setting up the request that triggered an Error
              this.submitStatus = "Error";
              this.$snotify.error(`${error.message}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          });
      }, 1200);
    },
  },
};
</script>
